<template>
  <div class="slide nord">
    <vue-link :to="`/shop/p/${product.handle}`" class="block">
      <figure>
        <img :src="coverImage.url" :alt="coverImage.altText" />
      </figure>

      <h2>{{ product.title }}</h2>

      <div v-if="product.availableForSale">
        <span v-if="firstAvailableVariant.compareAtPriceV2" class="compare-at-price">
          {{ compareAtPrice }}
        </span>
        <span :class="firstAvailableVariant.compareAtPriceV2 ? 'has-compare-at-price' : ''">
          {{ price }}
        </span>
      </div>
      <div v-else>
        Sold Out
      </div>
    </vue-link>
  </div>
</template>

<script>
import { formatMoney } from '@/lib/shopify-utils'

export default {
  name: 'ProductItem',
  props: {
    product: Object,
  },
  computed: {
    coverImage() {
      return this.product.featuredImage
    },
    firstAvailableVariant() {
      return this.product.selectedOrFirstAvailableVariant
    },
    price() {
      return formatMoney(this.firstAvailableVariant.priceV2.amount)
    },
    compareAtPrice() {
      return this.firstAvailableVariant.compareAtPriceV2.amount
    },
  },
}
</script>

<style scoped>
.slide {
  display: inline-block;
  white-space: normal;
}

.slide:last-child {
  padding-right: 2rem;
}

.block {
  border: 1px dashed #fff;
  border-radius: var(--br);
  padding: 3rem;
  text-align: center;

  position: relative;
  width: 40rem;
  height: 38rem;
  margin-left: 2rem;
  display: flex;
  flex-direction: column;
}

.block > * {
  pointer-events: none !important;
}

.block figure {
  flex: 1;
  position: relative;
  margin-bottom: 2rem;
}

.block img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
